module.exports = __webpack_public_path__ + "static/8-131868815fa7cd002d97af0997524be7.jpg";